import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { ArrowRight, MessageSquare, Sparkles } from "lucide-react";
import { Button } from "../ui/button";

export default function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const scrollToForm = () => {
    document.getElementById("solicitar-propuesta")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="guia-cta"
      className="section-spacing bg-galvani-bg relative overflow-hidden"
      data-testid="final-cta-section"
    >
      <div className="absolute top-10 right-10 w-72 h-72 bg-purple-300/20 rounded-full blur-3xl" />
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-blue-300/20 rounded-full blur-3xl" />

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="absolute -inset-4 bg-gradient-to-r from-blue-400/40 via-purple-400/40 to-pink-400/40 rounded-3xl blur-2xl" />
          <div className="relative p-8 md:p-12 lg:p-16 rounded-3xl bg-gradient-to-br from-galvani-blue via-galvani-purple to-galvani-pink shadow-2xl overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full blur-3xl" />

            <div className="relative text-center">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/20 backdrop-blur-md border border-white/20 mb-6">
                <Sparkles className="w-3.5 h-3.5 text-white" />
                <span className="text-xs text-white font-body font-semibold uppercase tracking-widest">Empieza hoy</span>
              </div>

              <div className="w-16 h-16 mx-auto rounded-2xl bg-white/20 backdrop-blur-md flex items-center justify-center mb-6">
                <MessageSquare className="w-8 h-8 text-white" />
              </div>

              <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white mb-4 drop-shadow-lg">
                ¿Listo para dominar tu sector?
              </h2>
              <p className="font-body text-white/90 text-lg mb-8 leading-relaxed max-w-xl mx-auto">
                Cuéntanos sobre tu proyecto y te preparamos una <strong className="text-white">propuesta a medida en 24h</strong>. Sin compromiso.
              </p>

              <ul className="grid sm:grid-cols-3 gap-3 sm:gap-6 mb-10 max-w-xl mx-auto text-sm text-white/90">
                <li className="flex items-center justify-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-white" />
                  Llamada de 20 min
                </li>
                <li className="flex items-center justify-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-white" />
                  Propuesta clara
                </li>
                <li className="flex items-center justify-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-white" />
                  Sin permanencia
                </li>
              </ul>

              <Button
                onClick={scrollToForm}
                className="bg-white hover:bg-slate-100 text-galvani-purple font-body font-bold px-10 h-14 text-lg rounded-full transition-all duration-300 hover:scale-[1.02] shadow-xl"
                data-testid="final-cta-primary"
              >
                Solicitar mi propuesta
                <ArrowRight size={18} className="ml-2" />
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
